import { FormApi, FieldState, AnyObject } from 'final-form';

import {
  CustomizableValidator,
  DefaultFieldValue,
  Validator
} from '../types/Validator';

export interface ConditionParams {
  value: DefaultFieldValue;
  allValues: AnyObject;
  fieldState?: FieldState<DefaultFieldValue>;
  extended: boolean;
  formApi: FormApi;
}

export type Condition = (args: ConditionParams) => boolean;

export interface ConditionalValidatorParams {
  condition: Condition;
  validator: Validator;
}

export const conditionalValidator: CustomizableValidator<
  ConditionalValidatorParams
> = ({ condition, validator }): Validator => (
  value,
  allValues,
  fieldState,
  client,
  extended,
  formApi
) =>
  condition({ value, allValues, fieldState, extended, formApi })
    ? validator(value, allValues, fieldState, client, extended, formApi)
    : undefined;
